import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import { useContext } from 'react';
import { cartContext } from './../../Context/CartContext';
import Box from '@mui/material/Box';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import TextField from '@mui/material/TextField';
import $ from 'jquery'
import {Helmet} from "react-helmet";

export default function AllProducts({userData}) {

  const baseURL = 'https://ecommerce.routemisr.com'  // or 'https://route-ecommerce-app.vercel.app'
  
  const navigate = useNavigate()
  const {add, remove, get, cartData, addToWishList, removeFromWishList, getUserWishList, wishList, setwishList} = useContext(cartContext)
  const [products, setproducts] = useState(null)
  const [cartProducts, setcartProducts] = useState(null)
  const [pageNums, setpageNums] = useState('')
  const [current, setcurrent] = useState('')
  const [productsLimit, setproductsLimit] = useState(null)
  const [productFilter, setproductFilter] = useState(null)
  const [flag, setflag] = useState(true)
  const [title, settitle] = useState('')
  const [wishMsg, setwishMsg] = useState('')
  
  // make limit of products displayed in the page 12 products.
  let limit = 12

  // Getting Products id that added previously to Cart
  let allCartID = cartData?.data?.products?.map((e)=>e.product._id)

  // Getting Products id that added previously to WishList
  let allWishListId = wishList?.map((e) => e._id)

  // check if no user data => clear allCartID & allWishList variables
  if (userData === null ) {
    allCartID = null
    allWishListId = null
  }
  
  
  // Display All Products with Search feature

  async function getAllProducts(title = '') {
    try {
      let allProducts

      // check flag to prevent calling API during search
      if (flag) {
        let data = await axios.get(`${baseURL}/api/v1/products`)
        allProducts = data.data.data
        let allPages = data.data.metadata.numberOfPages

        // for Loop to get products from second page
        for (let i = 2; i <= allPages; i++) {
          let data = await axios.get(`${baseURL}/api/v1/products`, {params : {'page': i}})
          allProducts = allProducts.concat(data.data.data)
        }
        setflag(false)
        setproducts(allProducts)
      }

      // function to check if no search done, display all products else display the searched products
      let allProd = ((!productFilter) ? allProducts: products)
      
      // make filter in case of title not empty to get the aimed products.
      if (title !== '') {
        allProd = allProd.filter((e) => e.title.toUpperCase().includes(title.toUpperCase()) ) 
      }

      // get pages number:
      let pages = Math.ceil(allProd.length / limit) 
      setpageNums(pages)
      setproductFilter(allProd)
      setproductsLimit(allProd.slice(0, 12))

      // on rendering make the first page display
      setcurrent(1)
      currentPage(1)

    } catch (error) {
      console.log(error);
    }
    }


  function paginationFun(page) {
    let start, end
    start = (page - 1) * limit
    end = start + limit
    setproductsLimit(productFilter.slice(start, end))
    setcurrent(page)
    currentPage(page)
  }

  // Make array of page Numbers for Pagination

  let pages = new Array(pageNums).fill(1).map((_, idx)=> idx+1)


  // Add to Wish Lish

  async function addProductToWishList(id, index) {
    //  check Status of user
    if (userData === null) {
      navigate('/login')
    }
    else {
      let response = await (addToWishList(id))
      if (response !== false) {
        setwishList(response.data)
        setwishMsg(response.message)

        // Show Sucess Msg 
        $(`#wishAdded${index}`).fadeIn(300, ()=> {
          setTimeout(() => {
            $(`#wishAdded${index}`).fadeOut(300)
          }, 2000);
        })

        
      }
    }
  }

  async function removeProductFromWishList(id, index) {
    let response = await removeFromWishList(id)
    if (response !== false) {
      setwishMsg(response.message)
      setwishList(response.data)
      $(`#wishRemoved${index}`).fadeIn(300, ()=> {
        setTimeout(() => {
          $(`#wishRemoved${index}`).fadeOut(300)
        }, 2000);
      })
    
    }
  }
  
  
  //Add Product to Cart

  async function addProduct(id, index) {
    if (userData === null) {
      navigate('/login')
    }
    else {
      let response = await add(id)
      if (response !== false) {
        let idResponse = response.data.products.map((e)=>e.product)
        setcartProducts(idResponse)
        $(`#successMsg${index}`).fadeIn(200, ()=> {
          setTimeout(() => {
            $(`#successMsg${index}`).fadeOut(200)
          }, 2000);
        })
    }
  }
}
  async function removeProduct(id, index) {
    let response = await remove(id)
    if (response !== false) {
      let idResponse = response.data.products.map((e)=>e.product)
        setcartProducts(idResponse)

        // Show success msg:
      $(`#deleteMsg${index}`).fadeIn(200, ()=> {
        setTimeout(() => {
          $(`#deleteMsg${index}`).fadeOut(200)
        }, 2000);
      })
    }
  }


  // Call get logged user Cart & WishLish Api to get the Cart and WishList of the user: 

  async function getData(){
    await  get();
    await getUserWishList()   
  }
  function currentPage(page) {

    $(".pagination .bgMain").removeClass("bgMain");
    $(`#page${page}`).addClass('bgMain')
}
  useEffect( ()=> {
    getAllProducts(title)
    getData()
    setTimeout(() => {
      $(`#page1`).addClass('bgMain');
    }, 0);
  }, [title])
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Fresh Cart Home</title>
      </Helmet>

      {productsLimit ? (
        <>
          <section className="row py-3">
            {/* Search bar from Material UI */}
            <div className="mb-3">
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <ManageSearchIcon sx={{ color: "#0aad0a", mr: 1, my: 0.5 }} />
                <TextField
                  id="input-with-sx"
                  label="Type to search..."
                  variant="standard"
                  onChange={(e) => settitle(e.target.value)}
                />
              </Box>
            </div>

            {/* Loop on products to display it */}
            {productsLimit?.map((product, index) => (
              <div key={index} className="col-md-4 col-lg-3 col-xl-2 mt-3">
                <div className="product px-2 py-3 h-100 position-relative ">
                  {/* check if data in WisList of user display the WishList Products */}
                  {wishList?.includes(product._id) ||
                  allWishListId?.includes(product._id) ? (
                    <span
                      className="position-absolute p-1 cursor-pointer rounded-circle star border-0"
                      title="Remove from WishList"
                      onClick={() =>
                        removeProductFromWishList(product._id, index)
                      }
                    >
                      <i className="fa-solid fa-heart text-main"></i>
                    </span>
                  ) : (
                    <span
                      id={`wishAdd${index}`}
                      className=" position-absolute p-1 cursor-pointer rounded-circle Btn star border-0"
                      title="Add to WishList"
                      onClick={() => addProductToWishList(product._id, index)}
                    >
                      <i className="fa-regular fa-heart"></i>
                    </span>
                  )}

                  {/* display Product Img */}
                  <img
                    src={product?.imageCover}
                    className="w-100"
                    alt={product.title}
                  />

                  {/* make link to go to product details */}
                  <Link to={`/productdetails/${product._id}`}>
                    <span className="look Btn rounded-3 w-75 m-auto">
                      Quick Look<i className="ms-2 fa-solid fa-expand"></i>
                    </span>
                  </Link>

                  {/* display Product category */}
                  <span className="text-main font-sm fw-bold">
                    {product?.category?.name}
                  </span>

                  {/* sisplay Product title (name) */}
                  <h3 className=" h6 fw-bolder">
                    {product?.title?.split(" ").slice(0, 2).join(" ")}
                  </h3>

                  {/* Display Price & Rating of the product  */}
                  <div className="d-flex justify-content-between">
                    {/* Check if product has price after discount */}
                    <p>
                      {product?.priceAfterDiscount ? (
                        <>
                          <span className=" text-decoration-line-through text-muted moderate">
                            {product?.price}
                          </span>{" "}
                          <span className=" text-muted fw-bold">
                            {product?.priceAfterDiscount}EGP
                          </span>
                        </>
                      ) : (
                        <span className="text-muted fw-bold">
                          {product?.price}EGP
                        </span>
                      )}
                    </p>

                    {/* display rating Average */}
                    <p>
                      <span className="moderate">
                        {product?.ratingsAverage}{" "}
                        <i className="fas fa-star rating-color moderate"></i>{" "}
                      </span>
                    </p>
                  </div>

                  {/* check if data in WisList of user display the Cart Products */}
                  {cartProducts?.includes(product._id) ||
                  allCartID?.includes(product._id) ? (
                    <span
                      id={`remove${index}`}
                      onClick={() => removeProduct(product._id, index)}
                      className="btn btn-outline-danger w-100 mt-2"
                    >
                      Remove
                      <i className="ms-2 fs-5 fa-regular fa-trash-can"></i>
                    </span>
                  ) : (
                    <span
                      id={`add${index}`}
                      onClick={() => addProduct(product._id, index)}
                      className="btn Btn w-100 addBtn"
                    >
                      Add <i className="ms-2 fs-5 fa-solid fa-cart-plus"></i>
                    </span>
                  )}

                  {/* Handling Success messages of add & remove from (Cart || Wishlish) */}
                  <div
                    id={`successMsg${index}`}
                    className="alert alert-success successMsg"
                    style={{ display: "none" }}
                  >
                    Product added successfully to your cart{" "}
                    <i className="me-2 fs-5 fa-regular fa-thumbs-up"></i>
                  </div>
                  <div
                    id={`wishAdded${index}`}
                    className="alert alert-success "
                    style={{ display: "none" }}
                  >
                    {wishMsg}
                    <i className="ms-2 fs-5 fa-regular fa-thumbs-up"></i>
                  </div>
                  <div
                    id={`wishRemoved${index}`}
                    className="alert alert-danger"
                    style={{ display: "none" }}
                  >
                    {wishMsg}
                  </div>
                  <div
                    id={`deleteMsg${index}`}
                    className="alert alert-danger deleteMsg"
                    style={{ display: "none" }}
                  >
                    Product Removed successfully from your cart
                  </div>
                </div>
              </div>
            ))}
          </section>

          {/* Pagination */}
          <nav aria-label="Page navigation example">
            <ul className="pagination d-flex justify-content-center">
              {/* Previous Page */}
              <li className="page-item ">
                <span
                  className="page-link Btn cursor-pointer"
                  aria-label="Previous"
                  onClick={() => paginationFun(current - 1)}
                >
                  <span aria-hidden="true">&laquo;</span>
                </span>
              </li>

              {/* Current Page */}
              {pages.map((page, idx) => (
                <li key={idx} className="page-item bg-main">
                  {/* <span
                    id={`page${idx + 1}`}
                    onClick={() => paginationFun(page)}
                    className="page-link  customSpan Btn  cursor-pointer"
                  > */}
                  <span
                    id={`page${page}`}
                    onClick={() => paginationFun(page)}
                    className={`page-link customSpan Btn cursor-pointer ${current === page ? 'bgMain' : ''}`}
                  >
                    {page}
                  </span>
                </li>
              ))}

              {/* Next Page */}
              <li className="page-item">
                <span
                  className="page-link Btn cursor-pointer"
                  aria-label="Next"
                  onClick={() => paginationFun(current + 1)}
                >
                  <span aria-hidden="true">&raquo;</span>
                </span>
              </li>
            </ul>
          </nav>

          {/* Display Loading Screen in case of Problem in Data (API) or request data time */}
        </>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
  
}
